export default ($resource) => {
    const baseUrl = `${SEED_CORE.ENV.API_URL}course/course-training`;
    const url = `${baseUrl}/:id`;
    return $resource(url, null, {
        updateMaterials: {
            method: 'POST',
            url: `${url}/update-materials`,
            isArray: false
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/CourseTraining/index.js